module.exports = __webpack_public_path__ + "static/media/InstagramLogo.a42addb9.svg";